import { render, staticRenderFns } from "./NewMatchedItems.vue?vue&type=template&id=c36d0fbc&scoped=true&"
import script from "./NewMatchedItems.vue?vue&type=script&lang=ts&"
export * from "./NewMatchedItems.vue?vue&type=script&lang=ts&"
import style0 from "./NewMatchedItems.vue?vue&type=style&index=0&id=c36d0fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36d0fbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VBtn,VCol,VContainer,VDatePicker,VMenu,VRow,VTextField,VTimePicker})
